(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insomnus-shop-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  
  const host = document.querySelector('.insomnus-shop-mark');
  if (!host) return;
  const canvas = document.createElement('canvas');
  canvas.setAttribute('aria-hidden', 'true');
  canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none';
  host.prepend(canvas);
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  const phi = (1 + Math.sqrt(5)) / 2;
  const vertices = [[-1,phi,0],[1,phi,0],[-1,-phi,0],[1,-phi,0],[0,-1,phi],[0,1,phi],[0,-1,-phi],[0,1,-phi],[phi,0,-1],[phi,0,1],[-phi,0,-1],[-phi,0,1]];
  const faces = [];
  const adjacent = (a,b) => Math.abs(vertices[a].reduce((s,v,i)=>s+(v-vertices[b][i])**2,0)-4)<.001;
  for(let a=0;a<12;a++) for(let b=a+1;b<12;b++) for(let c=b+1;c<12;c++) if(adjacent(a,b)&&adjacent(b,c)&&adjacent(a,c)) faces.push([a,b,c]);
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let width=0,height=0;
  let frame=0,visible=true;
  function schedule(){if(!frame&&!document.hidden&&visible)frame=requestAnimationFrame(draw);}
  new ResizeObserver(() => {width=canvas.clientWidth||host.clientWidth;height=canvas.clientHeight||host.clientHeight;const d=Math.min(devicePixelRatio,2);canvas.width=width*d;canvas.height=height*d;ctx.setTransform(d,0,0,d,0,0);schedule();}).observe(canvas);
  new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible)schedule();else{cancelAnimationFrame(frame);frame=0;}}).observe(host);
  document.addEventListener('visibilitychange',()=>{if(document.hidden){cancelAnimationFrame(frame);frame=0;}else schedule();});
  reduced.addEventListener('change',schedule);
  new MutationObserver(schedule).observe(document.body,{attributes:true,attributeFilter:['data-portal']});
  new MutationObserver(schedule).observe(document.documentElement,{attributes:true,attributeFilter:['data-theme','data-motion']});
  let lastAngle=.4,lastTime=null;
  function draw(t){
    frame=0;
    const paused=document.documentElement.dataset.motion==='paused';
    const elapsed=lastTime===null?0:Math.min(Math.max(t-lastTime,0),50);
    const angle = reduced.matches ? .4 : paused ? lastAngle : lastAngle+elapsed*.00012;
    lastTime=paused||reduced.matches?null:t;
    lastAngle=angle;
    const points = vertices.map(([x,y,z])=>{const xx=x*Math.cos(angle)+z*Math.sin(angle);const zz=z*Math.cos(angle)-x*Math.sin(angle);const yy=y*Math.cos(.4)-zz*Math.sin(.4);const depth=y*Math.sin(.4)+zz*Math.cos(.4);const scale=Math.min(width,height)*.27/(1+depth*.12);return [width/2+xx*scale,height/2+yy*scale,depth];});
    ctx.clearRect(0,0,width,height);
    const dark=document.documentElement.dataset.theme==='dark';
    const world='merch';
    const colors={merch:'#a3ff12',vt:'#ffd166',everyday:'#b89cff',creative:'#a4ffe1',clients:'#ffcf8a'};
    const color=colors[world]||(dark?'#d8ff53':'#658a18');
    faces.slice().sort((a,b)=>a.reduce((s,i)=>s+points[i][2],0)-b.reduce((s,i)=>s+points[i][2],0)).forEach(face=>{ctx.beginPath();face.forEach((i,n)=>ctx[n?'lineTo':'moveTo'](points[i][0],points[i][1]));ctx.closePath();ctx.fillStyle=color+'12';ctx.strokeStyle=color;ctx.lineWidth=1.35;ctx.fill();ctx.stroke();});
    if(!reduced.matches&&!paused)schedule();
  }
  schedule();
})();


  } catch(e) { console.error(e); }
})();
})();
